<template>
  <div>
    <div class="header">
      <span>随访统计</span>
      <el-form :inline="true" class="header-right">
        <el-form-item>
          <el-radio-group v-model="dateRadio" size="mini" @change="dateRadioChange">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="start"
            :type="dateType"
            size="mini"
            placeholder="开始日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="end"
            :type="dateType"
            size="mini"
            placeholder="结束日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border v-loading="loading" stripe style="width: 100%;">
      <el-table-tree-column
        parentKey="pid"
        treeKey="oid"
        file-icon="icon icon-file"
        folder-icon="icon icon-folder"
        prop="oname"
        label="组织"
        width="200">
      </el-table-tree-column>
      <el-table-column
        label="图表">
        <template slot-scope="props">
          <eber-follow-bar v-if="props.row.total" :followup-data="props.row" :maxData="maxData"></eber-follow-bar>
          <div v-else style="text-align: center;">暂无数据</div>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <div class="follow-foot">
        <div class="bar" style="background-color: #F2F2F2;"></div>
        <div style="width: 80px">出院患者</div>
        <div class="bar" style="background-color: #61A8E8;"></div>
        <div style="width: 40px">计划</div>
        <div class="bar" style="background-color: #7ECF51;"></div>
        <div style="width: 40px">完成</div>
        <div class="bar" style="background-color: #EECB5F;"></div>
        <div style="width: 40px">不良</div>
      </div>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import ListUtils from '@/utils/list'
  import moment from 'moment'
  import FollowupCountService from '@/request/count/followup'
  import EberFollowBar from "./eber-followup-bar";
  import ElTreeGrid from 'element-tree-grid'
  export default {
    name: 'CountFollowup',
    components: {
      'el-table-tree-column': ElTreeGrid,
      'eber-follow-bar': EberFollowBar
    },
    props: {
      orgs: {
        type: Array,
        default() {
          return [0]
        }
      }
    },
    data () {
      return {
        start: moment().subtract(6, 'days').startOf('day').valueOf(), // 开始时间
        end: moment().endOf('day').valueOf(), // 结束时间
        dateRadio: '日',
        dateType: 'date',
        tableData: [],
        loading: false,
        maxData: 0, // 最大值
        timer: false,
      }
    },
    created() {
      this.followupCountOrg();
    },
    watch:{
      orgs(){
        this.followupCountOrg();
      }
    },
    methods: {
      followupCountOrg() {
        this.loading = true
        if (this.orgs.length <= 0) {
          return
        }
        const orgIds = [];
        _.forEach(this.orgs, val => {
          orgIds.push(val.id);
        });
        let type = 'day';
        if (this.dateType !== 'date') {
          type = this.dateType
        }
        FollowupCountService.countOrg({
          start: moment(this.start).startOf(type).valueOf(),
          end: moment(this.end).endOf(type).valueOf(),
          oids: orgIds.toString(),
        }).then( res => {
          const followupList = _.orderBy(res.result || [], ['total'], ['desc']);
          const _tableData = ListUtils.listToTree(followupList, 'oid', 'pid', 'children');
          if (_tableData.length === 1) {
            this.tableData = _tableData[0].children
          } else {
            this.tableData = _tableData
          }
          this.maxData = _tableData[0].total || 0;
        }).finally(() => {
          this.loading = false
        })
      },
     /* toTree(followupList){
        let result = [], temp = {}, i = 0, j = 0, max = 0, len = followupList.length;
        for(; i < len; i++){
          temp[followupList[i]['oid']] = followupList[i]; // 以id作为索引存储元素，可以无需遍历直接定位元素
          if (max < followupList[i].total) {
            max = followupList[i].total
          }
        }
        for(; j < len; j++){
          var currentElement = followupList[j];
          var tempCurrentElementParent = temp[currentElement['pid']]; // 临时变量里面的当前元素的父元素
          if (tempCurrentElementParent) { // 如果存在父元素
            if (!tempCurrentElementParent['children']) { // 如果父元素没有chindren键
              tempCurrentElementParent['children'] = [] // 设上父元素的children键
            }
            tempCurrentElementParent['children'].push(currentElement) // 给父元素加上当前元素作为子元素
          } else { // 不存在父元素，意味着当前元素是一级元素
            result.push(currentElement);
          }
        }
        return {result,  max};
      },*/
      dateRadioChange(event) {
        switch (event) {
          case '年':
            this.dateType = 'year';
            this.start = moment().subtract(4, 'year').startOf('year').valueOf(); // 开始时间
            this.end =  moment().endOf('year').valueOf(); // 结束时间
            break;
          case '月':
            this.dateType = 'month';
            this.start = moment().subtract(12, 'month').startOf('month').valueOf(); // 开始时间
            this.end =  moment().endOf('month').valueOf(); // 结束时间
            break;
          default:
            this.dateType = 'date';
            this.start = moment().subtract(6, 'days').startOf('day').valueOf(); // 开始时间
            this.end =  moment().endOf('day').valueOf(); // 结束时间
        }
        this.dateChange();
      },
      dateChange() {
        if (!this.start || !this.end) {
          this.$message({
            message: '开始时间或结束时间不能为空',
              type: 'warning'
          });
          return
        }
        if (this.start > this.end) {
          this.$message({
            message: '开始时间不能大于结束时间',
              type: 'warning'
          });
        }
        this.followupCountOrg();
      }
    },
  }
</script>

<style scoped>
  .header {
    height: 50px;
    line-height: 48px;
    color: #000;
    border-bottom: 1px solid #ebeef5;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
  }
  .header-right{
    z-index: 999;
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
  }
  .follow-foot {
    text-align: center;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 30px;
    width: 200px;
  }
  .bar {
    min-width: 10px;
    height: 10px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
  }
</style>
